"use strict";

var _interopRequireDefault = require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _dashboard = require("@/api/dashboard");
var _vuex = require("vuex");
var _microApp = _interopRequireDefault(require("@micro-zoe/micro-app"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _default = {
  name: 'Dashboard',
  data: function data() {
    return {
      temp: {},
      list: [],
      formVisible: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['apps', 'user', 'token', 'authorize'])),
  watch: {
    $route: function $route(to, from) {
      console.log(to, from);
    }
  },
  created: function created() {
    var _this = this;
    // 获取看板
    (0, _dashboard.getList)().then(function (res) {
      _this.list = res.data;
    });
  },
  methods: {
    getEntry: function getEntry(item) {
      var app = this.apps.find(function (app) {
        return app.name == item.app;
      }) || {};
      if (typeof app == 'undefined') {
        return '/';
      }
      if (app.entry.indexOf('http') == -1) {
        return window.location.origin + app.entry;
      }
      return app.entry;
    },
    beforeMount: function beforeMount(item) {
      var app = this.apps.find(function (app) {
        return app.name == item.app;
      }) || {};
      var route = item.route ? {
        path: item.route
      } : {
        path: '/dashboard'
      };
      _microApp.default.setData(item.name, {
        app: app,
        route: route,
        user: this.user,
        token: this.token,
        authorize: this.authorize
      });
    },
    // 监听子应用数据
    dataChange: function dataChange(e) {
      var _this2 = this;
      var data = e.detail.data;
      console.log('=======', data);
      if (data.route) {
        // 此处不允许控制基座路由,否则仪表盘无法显示一个应用的多个模块
        setTimeout(function () {
          _this2.$router.push({
            path: '/dashboard'
          });
        }, 1000);
      }
      // 监听应用消息
      if (data.msg) {
        this.$store.dispatch('app/sendMsg', data.msg);
      }
    },
    handleUpdate: function handleUpdate(command) {
      var item = this.list[command.index];
      switch (command.action) {
        case 'update':
          this.temp = item;
          this.formVisible = true;
          break;
        case 'hidden':
          (0, _dashboard.updateStatus)({
            id: item.id,
            status: 0
          });
          this.list.splice(command.index, 1);
          break;
        default:
          break;
      }
    },
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$update, code, msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _dashboard.update)({
                id: this.temp.id,
                sort: this.temp.sort,
                title: this.temp.title,
                status: this.temp.status
              });
            case 2:
              _yield$update = _context.sent;
              code = _yield$update.code;
              msg = _yield$update.msg;
              if (!code) {
                this.$message.success(msg);
                this.formVisible = false;
              } else {
                this.$message.error(msg);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }
};
exports.default = _default;